import React from 'react';
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {useTranslation} from "react-i18next";
import Grid from "@mui/material/Grid";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from "@mui/material/IconButton";
import {getStoreFromUrl} from "../../../../utils/store";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import MaterialLink from "@mui/material/Link";
import Button from "../../../inputs/Button";


const Row = ({link, count, first, last, onDelete, changeOrder, disabled, onVisibilityChange}) => {
    const {t} = useTranslation();
    const {Icon, Key} = getStoreFromUrl(link.Link);

    return (
        <TableRow>
            <TableCell style={{width: '40px'}}>
                <img width={40} src={Icon} alt={t('store_icon')}/>
            </TableCell>
            <TableCell>
                {t('store_' + Key)}
            </TableCell>
            <TableCell>
                <MaterialLink href={link.Link} rel="noopener noreferrer">{link.Link}</MaterialLink>
            </TableCell>
            <TableCell>
                <IconButton
                    disabled={disabled}
                    onClick={e => onVisibilityChange(link, link.Visible === 'Y' ? 'N' : 'Y')}
                    size="large">
                    {(link.Visible === 'Y') && <VisibilityIcon/>}
                    {(link.Visible === 'N') && <VisibilityOffIcon/>}
                </IconButton>
            </TableCell>
            {!disabled && <TableCell align="right">
                <Grid container alignItems='center' justifyContent='space-between'>
                    <Grid item>
                        <Button variant='text' color='secondary' onClick={e => onDelete(link)}>
                            {t('delete_btn')}
                        </Button>
                    </Grid>
                    <Grid item>
                        <Grid container direction='column'>
                            {!first && <Grid item>
                                <IconButton onClick={e => changeOrder(link, -1)} size="large">
                                    <ExpandLessIcon/>
                                </IconButton>
                            </Grid>}
                            {(count > 0 && !last) && <Grid item>
                                <IconButton onClick={e => changeOrder(link, 1)} size="large">
                                    <ExpandMoreIcon/>
                                </IconButton>
                            </Grid>}
                        </Grid>
                    </Grid>
                </Grid>
            </TableCell>}
        </TableRow>
    );
};

export default Row;